import React, { SVGProps } from 'react';

export default ({ ...props }: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="22" cy="22" r="21" stroke="#065C5D" />
    <path d="M14.5 22.3469H29.6875" stroke="#065C5D" strokeWidth="2.7" strokeLinecap="round" />
    <path d="M22.3469 14.5V29.6875" stroke="#065C5D" strokeWidth="2.7" strokeLinecap="round" />
  </svg>
);
